import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import { ROLES } from '~/src/utils/constants';
import RolesDependent from '../RolesDependent';
import NavLink from './NavLink';

import pencilIcon from '../../../static/img/pencilIcon.svg';
import bulletIcon from '../../../static/img/bulletIcon.svg';
import kanbanIcon from '../../../static/img/kanbanIcon.svg';
import mathOperationsIcon from '../../../static/img/mathOperationsIcon.svg';

export default function PurchaseSecondaryNavigation(): React.ReactElement {
  const location = useLocation();
  let { id } = useParams();

  const navigationData = [
    {
      title: 'Orders List',
      subTitle: '',
      link: '/purchase-orders',
      isSelected: location.pathname === '/orders',
      isDisabled: false,
      icon: bulletIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ],
    },
    {
      title: 'Order Edit',
      subTitle: '',
      link: `/purchase-orders/edit/${id}`,
      isSelected: location.pathname === `/purchase-orders/edit/${id}`,
      isDisabled: !id,
      icon: pencilIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT,
      ],
    },
    {
      title: 'Select Products',
      subTitle: '',
      link: `/purchase-orders/details/${id}`,
      isSelected: location.pathname === `/purchase-orders/details/${id}`,
      isDisabled: !id,
      icon: kanbanIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ],
    },
    {
      title: 'Order Calculations',
      subTitle: '',
      link: `/purchase-orders/calculations/${id}`,
      isSelected: location.pathname === `/purchase-orders/calculations/${id}`,
      isDisabled: !id,
      icon: mathOperationsIcon,
      roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.SALES, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT],
    },
    {
      title: 'Deliveries',
      subTitle: '',
      link: `/purchase-delivery/${id}`,
      isSelected:
        location.pathname === `/purchase-delivery/${id}` ||
        location.pathname === `/purchase-delivery/create/${id}` ||
        location.pathname === `/purchase-delivery/edit/${id}`,
      isDisabled: !id,
      icon: mathOperationsIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT,
      ],
    },
  ];

  return (
    <StyledSecondaryNavigation>
      {navigationData.map((item) => (
        <div key={uuid()}>
          <RolesDependent roles={item.roles}>
            <NavLink
              title={item.title}
              link={item.link}
              isSelected={item.isSelected}
              isDisabled={item.isDisabled}
              subTitle={item.subTitle}
              icon={item.icon}
            />
          </RolesDependent>
        </div>
      ))}
    </StyledSecondaryNavigation>
  );
}

const StyledSecondaryNavigation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px 0;
  font-size: 14px;
  div:first-child {
    div {
      a {
        border-top-left-radius: 10px !important;
        border-bottom-left-radius: 10px !important;
      }
    }
  }
  div:last-child {
    div {
      a {
        border-top-right-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
      }
    }
  }
`;
